export enum AppLocale {
  English = "en-US",
  French = "fr-FR",
  Japanese = "ja-JA",
  Welsh = "cy-GB",
  Chinese = "zh-CN",
}

export enum StreamingProvider {
	Twilio = "twilio",
	Livekit = "livekit",
}

export enum Twilio {
  NetworkQualityLevelThreshold = 3,
  NetworkQualityLocal = 1,
  NetworkQualityRemote = 0
}

export enum SessionScope {
  AiProctor = "ai_proctor",
  CandidateAuth = "candidate_auth",
  LiveProctor = "live_proctor",
  RecordAndReview = "record_and_review"
}

export enum GrowthbookFeatureFlags {
  SecondaryCameraGrabEnabled = "pv_secondary_camera_grab_enabled"
}
